import React from "react";
import { ReferenceField, TextField } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { graduationRequests } from "api/graduationApi";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const TimeIntervalsMobileExpanded = ({ record }) => {
  return (
    record?.timeIntervals && (
      <Accordion sx={{ width: "100%" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
          <Typography sx={{ fontWeight: "bold" }}>Часови интервали</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ width: "100%" }}>
          {record.timeIntervals.map((item, idx) => (
            <div
              key={idx}
              style={settings.style.shadowBoxMobile}
            >
              <MobileListRow fields={[{ label: "Час", value: `${item.from} - ${item.to}` }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Тип дата",
                    value: (
                      <ReferenceField
                        record={item}
                        source="dateType"
                        reference={graduationRequests.getScheduleDateTypeSelect()}
                      >
                        <TextField source="nameBg" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default TimeIntervalsMobileExpanded;
